import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsArrowsCollapse, BsArrowsExpand } from 'react-icons/bs';
import { Space, Tooltip } from 'antd';

const CollapsibleField = ({ label, value }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div>
      <div className='border rounded-xl border-solid py-1 px-3 border-gray-200 dark:border-gray-800 '>
        <div
          className='cursor-pointer'
          onClick={() => {
            setCollapsed(!collapsed);
          }}
        >
          <Space className='btn'>
            <div className='font-semibold text-xs opacity-60'>{label ?? 'Unknown property'}</div>
            <div className='opacity-40 flex flex-col justify-center'>
              {collapsed ? (
                <Tooltip title='Click to expand'>
                  <BsArrowsExpand />
                </Tooltip>
              ) : (
                <Tooltip title='Click to collapse'>
                  <BsArrowsCollapse />
                </Tooltip>
              )}
            </div>
            <div>{collapsed ? <span className='font-extralight text-xs opacity-60'>(collapsed)</span> : ''}</div>
          </Space>
        </div>
        <div className={collapsed ? 'mx-2 my-2 max-h-4 overflow-hidden overflow-ellipsis' : 'mx-2 my-2 overflow-auto'} dangerouslySetInnerHTML={{ __html: value }} />
      </div>
    </div>
  );
};

CollapsibleField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CollapsibleField;
